<sol-dialog [dialog]="dialog$()" (action)="onAction($event)">
  <div class="sol-image-dialog" (click)="onSurroundClick()">
    @if (hasToolbar$()) {
      <div class="sol-image-dialog-toolbar" (click)="$event.stopPropagation()">
        <div class="sol-image-dialog-title sol-text-style-body-bold">{{ title$() }}</div>
        @if (actionButton$(); as actionButton) {
          <sol-button [button]="actionButton" (click)="onActionClick()" />
        }
      </div>
    }

    <div class="sol-image-dialog-body">
      @if (hasError$()) {
        <div class="sol-image-dialog-error" (click)="$event.stopPropagation()">
          <sol-icon [name]="SolIcon.warning" size="64" />
          <div class="sol-text-style-body-bold">{{ 'sol-empty-state.error-title' | translate }}</div>
          <div class="sol-text-style-body">{{ 'sol-image-dialog.load-error' | translate }}</div>
        </div>
      } @else if (loading$()) {
        <sol-loader [loader]="loader$()" (click)="$event.stopPropagation()" />
      } @else if (displaySrc$(); as displaySrc) {
        <img
          class="sol-image-dialog-image"
          [src]="displaySrc"
          [alt]="alt$()"
          (click)="$event.stopPropagation()"
          (error)="onLoadError()"
        />
      }
    </div>
  </div>
</sol-dialog>
